import axios from 'axios';

const version = 'v1';
const basePath = 'external-label';

export async function getContent(id) {
  return axios.request({
    url: `/${version}/${basePath}/content`,
    method: 'get',
    params: {
      id,
    },
  });
}
